module.exports = __webpack_public_path__ + "static/img/SpectrumHealth_Logo.34235ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/SpectrumHealth_Logo.png
// module id = kaUy
// module chunks = 0